import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '../../../translate';
import { ComponentForecastService } from '../component-forecast.service';
import { JobsiteInfoForCustomerVM, CompenentForecastVM, ForecastVM, equipmentListVM } from '../component-forecast.model';
import { ManageComponentsService } from '../../manage-components/manage-components.service';
import { AppService } from '../../../app.service';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import moment from 'moment';
import { ExcelService } from '../../manage-components/excel-service.service';
import { SelectionLists } from '../../../entities/global/model';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-component-forecast',
  templateUrl: './component-forecast.component.html',
  styleUrls: ['./component-forecast.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
    ExcelService
  ],
})


export class ComponentForecastComponent implements OnInit {


  //loading
  showTableView: boolean = false
  tableDataLoading: boolean = false

  equipmentid_auto: number
  serialno: number
  translateSubscription: Subscription;
  userLanguage: string = "english";
  modelID: number
  makeid: number
  typeid: number
  dealerID: number
  comptypeID: number
  cusID: number
  jobsiteID: number
  startDate: Date
  enddate: Date
  StartDateControl = new FormControl(moment());
  EndDateControl = new FormControl(moment());

  customerList
  jobsiteList: JobsiteInfoForCustomerVM[]
  userId: any

  dataSource = new MatTableDataSource();
  dataSourceTotal = new MatTableDataSource();
  dataSource_QuaterList = new MatTableDataSource();

  isLoad: boolean
  rdTotal_Details: number

  interval: number
  isQauter: boolean
  //checklist 
  Customer = true
  Jobsite = true
  ComponentID = true
  SerialNo = true
  UnitNo = true
  Make = true
  Family = true
  Model = true
  OEMPart = false
  MFRPart = false
  compoenetForecastList: CompenentForecastVM[]
  retList: ForecastVM[]
  resultColumHeaders: string[]
  displayedColumns = [];
  value: boolean
  retListForTotal
  equipmnentList: equipmentListVM[]
  newSelection: boolean
  dealerList
  selectionLists: SelectionLists = new SelectionLists();
  userName
  SerialNoList
  UnitNoList
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('componentPaginator') componentPaginator: MatPaginator;
  loadSize = 100;
  private _subscriptions: Subscription[] = [];

  constructor(
    public _translate: TranslateService,
    public _fleetService: ComponentForecastService,
    public _componentService: ManageComponentsService,
    public _appService: AppService,
    public excelService: ExcelService,
    private _notify: NotificationsService, ) { }

  ngOnInit() {
    this._appService.setPageTitle('Fleet Component Forecast');
    this._subscriptions.push(this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2)));
    this.dataSource.sort = this.sort;
    this._componentService.getComponentType();
    this._componentService.getComponentMakeList();
    this._componentService.getModelList();
    this._fleetService.getFamilyList();
    this._appService.GetLoggedInUserName().subscribe(result => {
      this.userName = result
      // this._fleetService.getDealerList(this.userName).subscribe(result => {
      //   this.dealerList = result
       // this.LoadCustomerList();
      });
    this._fleetService.getDealerList(this.userName).subscribe(result => {
      this.dealerList = result
      this.LoadCustomerList();
    });
    this.LoadCustomerList();

    this.isLoad = false;
    this.newSelection = false
    //checkList
    this.Customer = true
    this.Jobsite = true
    this.ComponentID = true
    this.SerialNo = true
    this.UnitNo = true
    this.Make = true
    this.Family = true
    this.Model = true
    this.isQauter = false
    this.startDate = new Date();
    this.interval = 2
    this.rdTotal_Details = 2
  }

  LoadCustomerList() {
    this._fleetService.getCustomerList(this.userName).subscribe(result => {
      this.customerList = result
    });
  }

  changeCheckbox(value: boolean, key, index: number) {
    if (value === false) {
      this.removeArrayelement(this.displayedColumns, key)
    } else {
      this.displayedColumns.splice(index, 0, key)
    }
  }

  removeArrayelement(arr, key) {
    let a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
      key = a[--L];
      while ((ax = arr.indexOf(key)) !== -1) {
        arr.splice(ax, 1);
      }
    }
    return arr;
  }


  updateUserLang(lang: string) {
    this.userLanguage = lang;
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  LoadCustomerListbyDealer(dealer: number) {
    this._fleetService.getCustomerListByDealer(dealer).subscribe(result => {
      this.customerList = result;
    })
  }

  resetFields() {
    this.jobsiteID = 0
    this.dealerID = 0;
    this.cusID = 0;
    this.serialno = 0;
    this.equipmentid_auto = 0;
    this.makeid = 0;
    this.typeid = 0;
    this.modelID = 0;
    this.comptypeID = 0;
    this.newSelection = false;

  }

  changeDealer(dealerid: number) {
    if (dealerid != 0) {
      this.LoadCustomerListbyDealer(dealerid)
      this.cusID = 0
      this.jobsiteID = 0
    }
    else {
      this.LoadCustomerList();
    }

  }
  changeJobsite(siteID: number) {
    this.loadEquipment(siteID);
  }
  LoadJobsiteList(customer: number) {
    this._fleetService.getJobSiteListByCustomer(customer).subscribe(result => {
      this.jobsiteList = result;
    })

  }

  loadEquipment(jobsiteID: number) {
    this._fleetService.getEquipmentList(jobsiteID).subscribe(result => {
      this.equipmnentList = result
    })
  }
  changeCustomer(cusid: number) {
    this.LoadJobsiteList(cusid);
  }

  displayedColumnsTotal

  loadCompForecastInfo() {


    if (this.enddate != null && this.interval != 0) {

      if (this.enddate < this.startDate) {
        this._notify.error("End Date must be greater than to start date");

      }
      else {


        this.newSelection = true
        this.Customer = true
        this.Jobsite = true
        this.ComponentID = true
        this.SerialNo = true
        this.UnitNo = true
        this.Make = true
        this.Family = true
        this.Model = true
        this.displayedColumns = []
        this.displayedColumnsTotal = []
        this.resultColumHeaders = []
        this.resultColumHeaders = []
        this.tableDataLoading = true


        this._fleetService.getcompForecastInfo(this.dealerID, this.startDate, this.enddate, this.interval, this.cusID,
          this.jobsiteID, this.makeid, this.typeid, this.modelID, this.comptypeID, this.equipmentid_auto).subscribe(r => {
            this.retList = r;
            this.displayedColumns = ['Customer', 'sitename', 'serialno', 'unitino', 'make', 'type', 'model', 'compart','comaptyType'];

            for (let j = 0; j < this.retList[0].timePeriod.length; j++) {

              this.displayedColumns.push(this.retList[0].timePeriod[j])
              this.resultColumHeaders.push(this.retList[0].timePeriod[j])
            }

            for (let element = 0; element < this.retList[0].data.length; element++) {

              for (let quterListID = 0; quterListID < this.retList[0].data[element].QuaterList.length; quterListID++) {
                let el = this.retList[0].data[element]
                let key
                this.retList[0].data[element].QuaterList[quterListID].month_val
                  ? key = this.retList[0].data[element].QuaterList[quterListID].month_val
                  : key = this.retList[0].data[element].QuaterList[quterListID].quater_year

                el[key] = this.retList[0].data[element].QuaterList[quterListID].ShouldHighLight

              }
            }

            this.showTableView = true
            this.dataSource.data = this.retList[0].data;
            this.tableDataLoading = false
            this.isLoad = true

            this.retListForTotal = this.retList[0].data

            let arrPartsTotal = this.remove_duplicates_safe(this.retListForTotal)
            this.displayedColumnsTotal = ['id', 'comaptyType']
            arrPartsTotal.map((item, index) => {
              let count = 0
              item.data.map((i, index1) => {
                let quater = i.quater
                item[quater] = i.total

                if (index == 0) {
                  this.displayedColumnsTotal.push(i.quater)
                }
              })
              count++;
            })
            this.dataSourceTotal.data = arrPartsTotal
            this.tableDataLoading = false
          })
      }
    }

    else {
      if (this.enddate == null) this._notify.error("Please Select End Date");
      if (this.interval == 0) this._notify.error("Please Select Interval");


    }
  }
  dublicateitems = []
  remove_duplicates_safe(arr) {
    var seen = {};
    var ret_arr = [];
    for (var i = 0; i < arr.length; i++) {
      if (!(arr[i].compart in seen)) {
        //  arr[i].push({total:1})
        let val = arr[i].compart
        let type = arr[i].comaptyType
        var seen_ = {};
        var ret_arr_ = [];

        let total = 0
        arr[i].QuaterList.map(item => {
          let timeperiod = item.quater_year!=null ? item.quater_year : item.month_val
          if (!(timeperiod in seen_)) {
            if (item.ShouldHighLight == 1) {
              ret_arr_.push({ quater: timeperiod, total: 1 })
            } else {
              ret_arr_.push({ quater: timeperiod, total: 0 })
            }


            seen_[timeperiod] = true;
          } else {
            ret_arr_.map(y => {
              if (y.quater == timeperiod) {
                if (item.ShouldHighLight == 1) {
                  y.total = y.total + 1
                }

              }
            })

          }


          // item.ShouldHighLight == 0 ? total+1 :total
          //  return total
        })
        ret_arr.push({ id: val, data: ret_arr_, comaptyType: type });
        ret_arr_ = []
        seen[arr[i].compart] = true;
      } else {
        var seen_ = {};
        var ret_arr_ = [];



        let total = 0
        arr[i].QuaterList.map(item => {

          ret_arr.map(k => {
            if (k.id == arr[i].compart && item.ShouldHighLight == 1) {
              k.data.map(l => {
                let timeperiod_ = item.quater_year!=null ? item.quater_year : item.month_val
                if (l.quater == timeperiod_) {
                  l.total = l.total + 1
                }
              })
            }

          })

        })


      }
    }
    return ret_arr;

  }



  getforecastClass(isReplace: number): string {
    let colurid = false;
    switch (isReplace) {
      case 0:
        colurid = false;
        break;
      default:
        colurid = true;
        break;
    }
    if (colurid == true) return ' x-bg';

  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.dataSource.data, 'Component Forecast');
  }



}
